import * as sessionReplay from '@amplitude/session-replay-browser'
import amplitude from 'amplitude-js'
import { UserTrackingProperties } from 'modules/common/types/tracking'
import { TrackingEvent } from './events'

const AMPLITUDE_ID = process.env.NEXT_PUBLIC_AMPLITUDE_ID || ''

let resolvedDeviceId: string | null = null

export const initAmplitude = () => {
  const instance = amplitude.getInstance()
  instance.init(AMPLITUDE_ID, undefined, { includeUtm: true })
  instance.onInit((readyInstance) => {
    resolvedDeviceId = readyInstance.getDeviceId()
  })
}

export const startSignupSessionReplay = async () => {
  const instance = amplitude.getInstance()
  const deviceId = resolvedDeviceId ?? instance.getDeviceId()
  const sessionId = instance.getSessionId()

  if (!AMPLITUDE_ID || !deviceId || !sessionId) {
    return
  }

  await sessionReplay.init(AMPLITUDE_ID, {
    deviceId,
    sessionId,
    sampleRate: 1,
    privacyConfig: {
      maskSelector: ['[data-amp-mask]'],
    },
  }).promise
}

export const stopSignupSessionReplay = () => {
  sessionReplay.shutdown()
}

export const setAmplitudeUserDevice = (installationToken: string) => {
  amplitude.getInstance().setDeviceId(installationToken)
}

export const setAmplitudeUserProperties = (
  properties: UserTrackingProperties
) => {
  amplitude.getInstance().setUserId(properties.corporateId || null)
  amplitude.getInstance().setUserProperties(properties)
}

export const resetAmplitudeUserProperties = () => {
  amplitude.getInstance().setUserId(null)
  amplitude.getInstance().setUserProperties(null)
}

export const sendAmplitudeData = (
  eventType: TrackingEvent,
  eventProperties?: any
) => {
  amplitude.getInstance().logEvent(eventType, {
    eventSource: 'FRONT_WEB',
    ...eventProperties,
  })
}
